import styled from 'styled-components'

export const ButtonPrimary = styled.button`
  background: var(--color-button-primary);
  min-width: 80px;
  line-height: normal;
  height: 48px;
  border-radius: 10px;
  border: none;
  color: var(--color-text-on-primary);
  font-size: 16px;
  padding: 0 16px;
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out, outline 0.2s ease-in-out;

  &:hover,
  &:focus {
    background: var(--color-button-primary-hover);
  }

  &:disabled {
    color: var(--color-text-on-primary);
    background: var(--color-disabled-fill);
  }

  &.outlined {
    background: white;
    border: 1px solid var(--color-button-primary);
    color: var(--color-button-primary);

    &:hover,
    &:focus {
      background: var(--color-primary-10);
    }

    &:disabled {
      color: var(--color-disabled-fill);
      //background: var(--color-disabled-fill);
      border-color: var(--color-disabled-fill);
      background: buttonface;
    }
  }
`

export const ButtonSecondary = styled.button`
  background: var(--bs-primary-rgb);
  min-width: 80px;
  line-height: normal;
  height: 48px;
  border-radius: 10px;
  border: none;
  padding: 0 16px;
  font-size: 16px;
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out, outline 0.2s ease-in-out;

  &:hover,
  &:focus {
    background: buttonface;
  }

  &:disabled {
    background: buttonface;
  }
`

export const ButtonDelete = styled.button`
  min-width: 80px;
  line-height: normal;
  height: 48px;
  border-radius: 10px;
  border: none;
  padding: 0 16px;
  font-size: 16px;
  background: var(--bs-primary-rgb);
  color: var(--color-coral-red);
  outline: 1px solid var(--color-coral-red);
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out, outline 0.2s ease-in-out;

  &:hover,
  &:focus {
    background: var(--color-coral-red-light);
  }

  &:disabled {
    outline: none;
    color: var(--color-text-on-primary);
    background: var(--color-disabled-fill);
  }

  &.fab {
    min-width: 32px;
    height: 32px;
    padding: 0 16px;
      border-radius: 100%;
  }
`
